import React, { useEffect, useState } from "react";
import HomeFour from "../pages/Home/HomeFour";
import Footer from "../common/Footer";
import Loading from "../common/Loading";
import Header from "../common/Header";

function HomepageLayout() {
  const [load, setLoad] = useState(false);
  useEffect(() => {
    setLoad(true);
    setTimeout(() => {
      setLoad(false);
    }, 3000);
  }, []);
  return (
    <>
      {load ? (
        <Loading />
      ) : (
        <>
          <Header />
          <HomeFour />
          <Footer className="footer-area" />
        </>
      )}
    </>
  );
}

export default HomepageLayout;
